<ui-map-with-sidebar
    [mapItems]="(mapItems$ | async) ?? fallbackMapItems"
    [popupContentComponentType]="popupContentComponentType"
    (reloadMapData)="reloadMapData()"
>
    <ui-filter-mapper filters />
    <ui-economic-development-map-item-details
        map-item-details
        [mapItem]="(detailViewItem$ | async) ?? undefined"
    />
</ui-map-with-sidebar>
